import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";

export const CONFIRM_ACCOUNT_FIELD = "facility_account_number_confirm";

export function useAccountConfirmReset(index: number): void {
  const { watch, setValue, getValues, clearErrors } = useFormContext<{
    branches: Record<string, unknown>[];
  }>();
  const primaryAccountValue = watch(
    `branches.${index}.facility_account_number`,
  ) as string | undefined;
  const previousPrimaryAccountRef = useRef<string | undefined>(
    primaryAccountValue,
  );
  useEffect(() => {
    const prev = previousPrimaryAccountRef.current;
    previousPrimaryAccountRef.current = primaryAccountValue;
    if (prev === undefined) return;
    if (prev === primaryAccountValue) return;
    const confirm = getValues(
      `branches.${index}.${CONFIRM_ACCOUNT_FIELD}`,
    );
    // Gate on mismatch — a persisted-draft restore lands primary + matching
    // confirm together, so a pure change check would wipe a confirmed pair
    // and re-prompt the vendor for a change they never made.
    if (
      typeof confirm === "string" &&
      confirm.length > 0 &&
      confirm !== primaryAccountValue
    ) {
      setValue(`branches.${index}.${CONFIRM_ACCOUNT_FIELD}`, "", {
        shouldDirty: true,
        shouldValidate: false,
      });
      clearErrors(`branches.${index}.${CONFIRM_ACCOUNT_FIELD}`);
    }
  }, [primaryAccountValue, index, setValue, getValues, clearErrors]);
}
